import React, { useContext, useEffect, useRef, useState } from "react"

import { Link, navigate } from "gatsby"

import { Icon } from "@components/icon"
import { AuthContext } from "@contexts/auth/auth"

import * as styles from "./account.module.css"

const Account = () => {
  const { user, isAuthenticated, logout } = useContext(AuthContext)
  const [open, setOpen] = useState(false)
  const menuRef = useRef(null)

  const handleLogout = () => {
    logout()
    navigate("/login")
  }

  useEffect(() => {
    if (!open) {
      return undefined
    }
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [open])

  if (isAuthenticated && user) {
    return (
      <div className={styles.userMenu} ref={menuRef}>
        <div
          className={styles.iconButton}
          role="button"
          tabIndex={0}
          aria-label={user.firstName || user.email || "My Account"}
          aria-haspopup="true"
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault()
              setOpen((prev) => !prev)
            }
          }}
        >
          <Icon id="user" width="27" height="27" />
          <Icon
            id={open ? "chevron-up" : "chevron-down"}
            width="14"
            height="14"
            className={styles.chevron}
          />
        </div>
        {open && (
          <div className={styles.dropdown}>
            <Link
              to="/portal/orders"
              className={styles.dropdownLink}
              onClick={() => setOpen(false)}
            >
              My Account
            </Link>
            <div
              className={styles.dropdownLink}
              role="button"
              tabIndex={0}
              onClick={handleLogout}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault()
                  handleLogout()
                }
              }}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <Link to="/login" className={styles.iconButton} aria-label="Login">
      <Icon id="user" width="27" height="27" />
    </Link>
  )
}

export default Account
